import React from 'react';
import DashboardCampaignPlans from '../../components/dashboard/DashboardCampaignPlans';
import { useAppSelector } from '../../store/store';
import { getCampaignsLoading } from '../../store/selector/common.selector';
import { Spinner } from 'react-bootstrap';

const Dashboard = () => {
    const fetchCampaignsLoading = useAppSelector(getCampaignsLoading);

    return (
        <div className="tw-flex tw-flex-col tw-items-center tw-mt-[20px] lg:tw-mt-[100px] tw-min-w-sm tw-px-5">
            <div className="tw-font-medium tw-text-base lg:tw-text-3xl tw-mb-10 tw-text-center">
                Hey, ready to level up your social media?
            </div>
            {fetchCampaignsLoading ? <Spinner variant="primary" /> : <DashboardCampaignPlans />}
        </div>
    );
};

export default Dashboard;
